/* tslint:disable */
/* eslint-disable */
/**
 * Clippd Spikemark API
 * # Overview Spikemark provides tournament scoring, real-time leader boards, detailed statistics, in-depth analytics and media through a platform that  includes easy-to-navigate screens allowing users to keep track of their favorite teams and players.  Clippd is an AI-focussed technology business building a connected future for golfers and coaches who have a passion for performance.  At our core is a universal platform that aggregates and elevates all the performance data created by millions of golfers and coaches every day.   This documentation provides the \"Spikemark API\", powered by the Clippd platform. The purpose of the API is to provide advanced analytics and  integration for rankings for collegiate golf.  In addition to this documentation, we also provide an [OpenAPI](https://github.com/OAI/OpenAPI-Specification/blob/master/versions/3.0.1.md)  specification describing the Clippd API Specification in [YAML](openapi.yaml) and [JSON](openapi.json) formats.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@clippd.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { TournamentPlayersRequestPlayersListInner } from './TournamentPlayersRequestPlayersListInner';
import {
  TournamentPlayersRequestPlayersListInnerFromJSON,
  TournamentPlayersRequestPlayersListInnerFromJSONTyped,
  TournamentPlayersRequestPlayersListInnerToJSON,
} from './TournamentPlayersRequestPlayersListInner';

/**
 * Request for adding/removing players to participating teams in a tournament
 * @export
 * @interface TournamentPlayersRequest
 */
export interface TournamentPlayersRequest {
  /**
   *
   * @type {string}
   * @memberof TournamentPlayersRequest
   */
  tournamentId: string;
  /**
   *
   * @type {string}
   * @memberof TournamentPlayersRequest
   */
  schoolId: string;
  /**
   *
   * @type {string}
   * @memberof TournamentPlayersRequest
   */
  teamLabel: TournamentPlayersRequestTeamLabelEnum;
  /**
   *
   * @type {Array<TournamentPlayersRequestPlayersListInner>}
   * @memberof TournamentPlayersRequest
   */
  playersList?: Array<TournamentPlayersRequestPlayersListInner>;
}

/**
 * @export
 */
export const TournamentPlayersRequestTeamLabelEnum = {
  A: 'A',
  B: 'B',
  C: 'C',
  D: 'D',
  E: 'E',
  W: 'W',
  Ind: 'IND',
} as const;
export type TournamentPlayersRequestTeamLabelEnum =
  (typeof TournamentPlayersRequestTeamLabelEnum)[keyof typeof TournamentPlayersRequestTeamLabelEnum];

/**
 * Check if a given object implements the TournamentPlayersRequest interface.
 */
export function instanceOfTournamentPlayersRequest(value: object): boolean {
  let isInstance = true;
  isInstance = isInstance && 'tournamentId' in value;
  isInstance = isInstance && 'schoolId' in value;
  isInstance = isInstance && 'teamLabel' in value;

  return isInstance;
}

export function TournamentPlayersRequestFromJSON(json: any): TournamentPlayersRequest {
  return TournamentPlayersRequestFromJSONTyped(json, false);
}

export function TournamentPlayersRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): TournamentPlayersRequest {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    tournamentId: json['tournamentId'],
    schoolId: json['schoolId'],
    teamLabel: json['teamLabel'],
    playersList: !exists(json, 'playersList')
      ? undefined
      : (json['playersList'] as Array<any>).map(TournamentPlayersRequestPlayersListInnerFromJSON),
  };
}

export function TournamentPlayersRequestToJSON(value?: TournamentPlayersRequest | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    tournamentId: value.tournamentId,
    schoolId: value.schoolId,
    teamLabel: value.teamLabel,
    playersList:
      value.playersList === undefined
        ? undefined
        : (value.playersList as Array<any>).map(TournamentPlayersRequestPlayersListInnerToJSON),
  };
}
